module.exports = __webpack_public_path__ + "static/media/donationSticker-hoh.476bedd3.png";